export default __webpack_public_path__ + "announcement-blob-1.svg";